import { invoke } from '@shared/easyfy.decorators';
import { globalEvent } from '@shared/easyfy.core';
import { removeCss } from '@shared/easyfy.utils';

namespace Easyfy.Components {
  @invoke
  class TableOfContentComponent {
    constructor() {}

    onInit() {
      globalEvent({
        type: 'click',
        event: {
          event: 'show-all-tableofcontent',
          callback: TableOfContentComponent.showAll,
        },
      });
    }

    static showAll(e: Event) {
      const target = e.target as HTMLElement;
      const tableOfContent = target?.parentElement;
      if (tableOfContent) removeCss(tableOfContent, 'collapsed');
    }
  }
}
